/**
 * @desc 视频监控添加
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.VideoMonitorAddRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/ProductionRealTime/addVideoMonitor',
    data,
  });
}

export function mock(
  data: defs.VideoMonitorAddRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/ProductionRealTime/addVideoMonitor',
    data,
  });
}
